import { useState, useEffect } from "react"
import { Modal, Select, Button, Form, message } from "antd"

const { Option } = Select

export default function AddPriorityModal({ isOpen, onClose, onAddPriority, metricOptions }) {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [selectedGroup, setSelectedGroup] = useState(null)

  useEffect(() => {
    if (!isOpen) {
      form.resetFields()
      setSelectedGroup(null)
    }
  }, [isOpen, form])

  const handleGroupChange = (value) => {
    setSelectedGroup(value)
    form.setFieldsValue({ metric: undefined }) 
  }

  const handleOk = async () => {
    try {
      setLoading(true)
      const values = await form.validateFields()
      onAddPriority({
        group: values.group,
        metric: values.metric,
      })
      message.success(`Priority "${values.metric}" added successfully!`)
      onClose()
    } catch (info) {
      console.log("Validate Failed:", info)
      message.error("Please fill in all required fields correctly.")
    } finally {
      setLoading(false)
    }
  }

  const currentGroupMetrics = metricOptions.find((opt) => opt.group === selectedGroup)?.metrics || []

  return (
    <Modal
      title={<div className="text-lg">Add New Radar Priority</div>}
      open={isOpen}
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
          Add Priority
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="group"
          label={<span>Priority Heading</span>}
          rules={[{ required: true, message: "Please select a priority heading!" }]}
        >
          <Select placeholder="Select a heading" onChange={handleGroupChange}>
            {metricOptions.map((group) => (
              <Option key={group.group} value={group.group}>
                {group.group}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="metric"
          label={<span>Metric/KPI Name</span>}
          rules={[{ required: true, message: "Please select a metric/KPI!" }]}
        >
          <Select
            placeholder="Select a metric/KPI"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            disabled={!selectedGroup}
          >
            {currentGroupMetrics.map((metric) => (
              <Option key={metric} value={metric}>
                {metric}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  )
}